import gql from "graphql-tag";
import { DOCUMENT_FRAGMENT } from "../document/fragment";

export const MEMBER_FRAGMENT = gql`
  fragment MemberInfo on Member {
    city
    directSharesPercentage
    directorAppointmentDate
    emailAddress
    firstName
    gender
    id
    isDirector
    isOwner
    isoCountryCode
    lastName
    nationalityCode
    phone
    postalCode
    street
    specifiedUSPerson
    documents {
      ...DocumentInfo
    }
    status
  }
  ${DOCUMENT_FRAGMENT}
`;
